import { QueryObserverBaseResult, useQuery } from "react-query";
import api from "../../client";
import { queryKeys } from "../../query";
import { UserDetailResponseData } from "../../types/user";

export const getData = async (id: string | undefined) => {
  const { data } = await api.get<UserDetailResponseData>(`/users/${id}`);

  return data;
};

export const useUser = (
  id: string | undefined,
): QueryObserverBaseResult<UserDetailResponseData> => {
  const { data, ...props } = useQuery(queryKeys.user(id), () => getData(id), {
    enabled: Boolean(id),
  });
  return { data, ...props };
};
